import { Calculation } from 'final-form-calculate'
import { MetaPath } from 'util/metaPath'
import { createMedicoesCalculations } from 'view/atendimentos/components/MedicoesPanel/calculator'

import { ObjetivoFormModel } from './ObjetivoForm'

export const createObjetivoCalculations = (meta: MetaPath<ObjetivoFormModel>): Calculation[] => [
  ...createMedicoesCalculations(meta.medicoes),
]
